
import search from '@/models/search.js'

const getDefaultState = () => {
  return {
    keyword: search.getkeyword(),
    type: search.gettype()
  }
}

const state = getDefaultState()

const mutations = {
  SET_KEYWORD: (state, value) => {
    state.keyword = value
  },

  SET_TYPE: (state, value) => {
    state.type = value
  }
}

const actions = {
  setKeyword({ commit }, value) {
    search.setkeyword(value)
    commit('SET_KEYWORD', value)
  },
  setType({ commit }, value) {
    search.settype(value)
    commit('SET_TYPE', value)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}

